import { render } from "./ViewTariffZone.vue?vue&type=template&id=a2a2d958&scoped=true&ts=true"
import script from "./ViewTariffZone.vue?vue&type=script&lang=ts"
export * from "./ViewTariffZone.vue?vue&type=script&lang=ts"

import "./ViewTariffZone.vue?vue&type=style&index=0&id=a2a2d958&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2a2d958"]])

export default __exports__